import React from 'react';
import { Navbar } from '../components/Navbar';
import { MediaInsightsPage } from '../components/MediaInsightsPage';
import { Footer } from '../components/Footer';
export const Media = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2349">
      <Navbar data-id="element-2350" />
      <MediaInsightsPage data-id="element-2351" />
      <Footer data-id="element-2352" />
    </div>;
};